// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LfeR","content":"styles_content__3vZ8s","row":"styles_row__3Z_oa","footer":"styles_footer__2QHTS","phraseLength":"styles_phraseLength__26_B6"};